import { getAxiosConfigUserToken } from "app/utils/appHelpers";
import axios from "axios";
import config from "config";


export const sendMailByMeetingIdPDFApi = async (
    id,
    infoType = "false",
    notType = "false",
    attachmentType = "false",
    mailText = null,
    smsText = null
) => {
    const url = `${config.apiUrl}/v1/notification/${id}/${infoType}/${notType}/${attachmentType}`;
    return axios.post(url, {
        mailText,
        smsText
    }, {
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    }).then(res => new Blob([res.data], { type: 'application/pdf' }));
}

